import {EntityData, field, identifier, transientField} from "@fedeltapointofsale/data-client";

export class ProductCountDownData extends EntityData<ProductCountDownData> {
    @identifier productCountDownId: string;
    @field locationId: number;
    @field sellableId: number;
    @field productCount: number;
    @field resetAtStartOfDay: boolean;
    @field restockLevel: number;
    @field soldOutToday: boolean;
    @field notSold: boolean;
    @field pinned: boolean;

    @transientField isDirty: boolean;
}
